export default __webpack_public_path__ + "static/media/tngd.08c40e43.svg";